<template>
  <ul class="product-badges">
    <li
      v-for="badge of badges"
      :key="badge"
      class="product-badges__item text-other-label-s"
      :class="{ 'oos': badge === 'oos' }"
      v-text="getBadgeName(badge)"
    />
  </ul>
</template>

<script>

/**
 * Vue: Product badges (product-badges)
 * -----------------------------------------------------------------------------
 * Metafield based product badges displayed in product card and PDP.
 * - Component settings: snippet / dynamic / async / scroll
 *
 * @param {Array} badges - Product badges.
 * @param {Boolean} [loading] - Loading state.
 *
 */
export default {
  name: 'ProductBadges',

  props: {
    badges: {
      type: Array,
      default: () => [],
    },
  },

  methods: {

    /**
     * Returns badge name.
     * @param {String} badge - Product badge.
     * @returns {String}
     */
    getBadgeName(badge) {
      let badgeName = badge

      if (badge === 'oos') {
        badgeName = this.$string('product.form.sold_out')
      }

      if (badge === 'pre-order') {
        badgeName = this.$string('product.badges.pre_order')
      }

      return badgeName
    },
  },
}
</script>

<style lang="scss">
@import './product-badges';
</style>
